import Robot, { getPackage } from './robotbase'


class Robotiq85 extends Robot {
	constructor() {
		super('Robotiq85', 'simple_arm_description', 'urdf/simple_arm_robotiq.urdf.xacro');

		this.packages.robotiq_2f_85_gripper_visualization = getPackage('robotiq_2f_85_gripper_visualization');

		this.robotRoot = 'base_link';
		this.handRoot = 'robotiq_arg2f_base_link';
		this.modelScale = 10;

		this.defaultPose = {
			joint_1: 0,
			joint_2: -0.8,
			joint_3: 1.15,
			joint_4: -0.35,
		};

		this.tcp.parent = 'robotiq_arg2f_base_link';
		this.tcp.position = [0, 0, 0.12];
		this.hand.invertOpenClose = true;

		this.ikEnabled = [
			'joint_1',
			'joint_2',
			'joint_3',
			'joint_4',
		];

		this.interactionJointLimits = {
			joint_1: { lower: -Math.PI, upper: Math.PI },
			joint_2: { lower: -1.8, upper: 1.35 },
			joint_3: { lower: -2.1, upper: 2.1 },
			joint_4: { lower: -2.2, upper: 2.2 },
		};
	}
}

module.exports = new Robotiq85();